import { addLanguageChangeReset } from "domains/language/reducerHelpers";
import type {
  TopicFetchContentMetaAction,
  TopicFetchContentMetaFailureAction,
  TopicFetchContentMetaSuccessAction,
} from "domains/topicSearchFilter/actionTypes";
import { TopicContentMetaTypes } from "domains/topicSearchFilter/actionTypes";
import type { TopicContentMetaState } from "domains/topicSearchFilter/types";

const initialState: TopicContentMetaState = {
  filters: {
    data: [],
    events: [],
    initiatives: [],
    latest: [],
    publications: [],
    signals: [],
    stakeholders: [],
    videos: [],
  },
  isLoaded: false,
};

type Action = TopicFetchContentMetaAction | TopicFetchContentMetaFailureAction | TopicFetchContentMetaSuccessAction;

const reducer = (state: TopicContentMetaState = initialState, action: Action): TopicContentMetaState => {
  switch (action.type) {
    case TopicContentMetaTypes.FETCH_CONTENT_META_SUCCESS:
      return {
        ...state,
        filters: action.payload.filters,
        isLoaded: true,
      };
    default:
      return state;
  }
};

export const topicContentMetaReducer = addLanguageChangeReset(reducer, initialState);
